import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";

import {
    fetchInappTemplateAll,
    createTemplateInapp,
    updateTemplateInapp

} from "@/services/inappTemplate";

@Module({
  namespaced: true
})
export default class inappTemplate extends VuexModule {

  // state
    fetchInappTemplateList = [];

  // Action

  @Action
  public async fetchInappTemplateAction(payload) {
    try {
      const data = await fetchInappTemplateAll(payload);
      this.context.commit("setInsappTemplateList", data.data);
      return data.data;
    } catch (err) {
      throw err;
    }
  }

  @Action
  public async createInappTemplate(payload) {
    try {
      const data = await createTemplateInapp(payload);
      return data;
    } catch (err) {
      throw err;
    }
  }

  @Action
  public async updateInappTemplate(payload) {
    try {
      const data = await updateTemplateInapp(payload);
      return data;
    } catch (err) {
      throw err;
    }
  }

  //Mutations

  @Mutation
  public setInappTemplateList(data: any) {
    this.fetchInappTemplateList = data;
  }

  //Getters
  get GetFetchInappTemplateList() {
    return this.fetchInappTemplateList;
  }

}
